import { js_utils } from "../utils/frfr-js-utils";
import { lib_document_utils_tabular_document_to_optimized_document } from "../utils/frfr-lib-document-utils";
import { _compatibility_fix_lib_materijal_lim_lib_obj } from "./ter-compatibility-utils";
import { terLibSifrarnikJedinice, terLibSifrarnikOp, terLibSifrarnikRadniCentri } from "./ter-params-lib";


let cache_state = {
  users_cache: [],
  users_is_cached: false,
  lib_ter_ter_const_cache: {},
  lib_ter_ter_const_is_cached: false,
  lib_ter_virtel_params_cache: {},
  lib_ter_virtel_params_is_cached: false,
  lib_ter_materijal_lim_cache: {},
  lib_ter_materijal_lim_is_cached: false,
  lib_cnc_s4_program_template_cache: {},
  lib_cnc_s4_program_template_is_cached: false,
  lib_ter_document_cache: {},
  lib_ter_document_is_cached: false,
  lib_ter_cparams_cache: {},
  lib_ter_cparams_cache_is_cached: false,
};


export const _cacheHelper_decodeLibEntityDataJsonV1 = (json) => {
  // HELPER
  let decoded_lib_obj = {};
  let decoded;
  try {
    decoded = JSON.parse(json);
  } catch (error) {
    console.log(error);
  }
  if (js_utils.is_object(decoded)) {
    decoded_lib_obj = decoded;
  }
  return decoded_lib_obj;
};


// cache GET, cache SET


/*
// za sada sifrarnik jedinica ne uzimamo iz baze nego je hardkodovan
export const ter_sifrarnik_jedinice_cache_set = (arr) => {
  //
};
*/
//
export const ter_sifrarnik_jedinice_cache_get = () => {
  // SIFRARNIK JEDINICA
  return terLibSifrarnikJedinice;
};

/*
// za sada sifrarnik operacija ne uzimamo iz baze nego je hardkodovan
export const ter_sifrarnik_op_cache_set = (arr) => {
  //
};
*/
//
export const ter_sifrarnik_operacije_cache_get = () => {
  // SIFRARNIK OPERACIJA
  return terLibSifrarnikOp;
};


/*
// za sada sifrarnik radni centri ne uzimamo iz baze nego je hardkodovan
export const ter_sifrarnik_radni_centri_cache_set = (arr) => {
  //
};
*/
//
export const ter_sifrarnik_radni_centri_cache_get = () => {
  // SIFRARRNIK RADNI CENTRI RESURSI
  return terLibSifrarnikRadniCentri;
};


export const users_cache_set = (arr) => {
  if (Array.isArray(arr)) {
    arr.forEach((item) => {
      cache_state.users_cache = [...arr];
    });
    cache_state.users_is_cached = true;
    console.log('users_is_cached');
  }
  return true;
};
//
export const users_cache_get = () => {
  return cache_state.users_cache;
};


export const lib_ter_ter_const_cache_set = (arr) => {
  // pretvaramo array u object i transformišemo iteme
  if (Array.isArray(arr)) {
    arr.forEach((item) => {
      if (item && item.lib_entity_key) {
        const data_json = item.data_json;
        const lib_obj = _cacheHelper_decodeLibEntityDataJsonV1(data_json);
        cache_state.lib_ter_ter_const_cache[item.lib_entity_key] = {
          // ...item,
          ...lib_obj, // koristimo samo ovaj deo entity-ja iz baze
        };
      }
    });
    cache_state.lib_ter_ter_const_is_cached = true;
    console.log('lib_ter_ter_const_is_cached');
  }
  return true;
};
//
export const lib_ter_ter_const_cache_get = () => {
  return cache_state.lib_ter_ter_const_cache;
};


export const lib_ter_virtel_params_cache_set = (arr) => {
  // pretvaramo array u object i transformišemo iteme
  if (Array.isArray(arr)) {
    arr.forEach((item) => {
      if (item && item.lib_entity_key) {
        const data_json = item.data_json;
        const lib_obj = _cacheHelper_decodeLibEntityDataJsonV1(data_json);
        cache_state.lib_ter_virtel_params_cache[item.lib_entity_key] = {
          // ...item,
          ...lib_obj, // koristimo samo ovaj deo entity-ja iz baze
        };
      }
    });
    cache_state.lib_ter_virtel_params_is_cached = true;
    console.log('lib_ter_virtel_params_is_cached');
  }
  return true;
};
//
export const lib_ter_virtel_params_cache_get = () => {
  return cache_state.lib_ter_virtel_params_cache;
};


export const lib_ter_materijal_lim_cache_set = (arr) => {
  // pretvaramo array u object i transformišemo iteme
  if (Array.isArray(arr)) {
    arr.forEach((item) => {
      if (item && item.lib_entity_key) {
        const data_json = item.data_json;
        const lib_obj = _cacheHelper_decodeLibEntityDataJsonV1(data_json);
        if (lib_obj.aktivan === true) { // only activated lib entities
          cache_state.lib_ter_materijal_lim_cache[item.lib_entity_key] = {
            // ...item,
            ..._compatibility_fix_lib_materijal_lim_lib_obj(lib_obj), // koristimo samo ovaj deo entity-ja iz baze
          };
        }
      }
    });
    cache_state.lib_ter_materijal_lim_is_cached = true;
    console.log('lib_ter_materijal_lim_is_cached');
  }
  return true;
};
//
export const lib_ter_materijal_lim_cache_get = () => {
  return cache_state.lib_ter_materijal_lim_cache;
};


export const lib_cnc_s4_program_template_cache_set = (arr) => {
  // pretvaramo array u object
  if (Array.isArray(arr)) {
    arr.forEach((item) => {
      if (item && item.template_filename) {
        cache_state.lib_cnc_s4_program_template_cache[item.template_filename] = {
          ...item
        };
      }
    });
    cache_state.lib_cnc_s4_program_template_is_cached = true;
    console.log('lib_cnc_s4_program_template_is_cached');
  }
  return true;
};
//
export const lib_cnc_s4_program_template_cache_get = () => {
  return cache_state.lib_cnc_s4_program_template_cache;
};


export const lib_ter_document_cache_set = (arr) => {
  // pretvaramo array u object i transformišemo iteme
  if (Array.isArray(arr)) {
    arr.forEach((item) => {
      if (item && item.lib_entity_key) {
        const data_json = item.data_json;
        const lib_obj = _cacheHelper_decodeLibEntityDataJsonV1(data_json);
        /*
        cache_state.lib_ter_document_cache[item.lib_entity_key] = {
          // ...item,
          ...lib_obj, // koristimo samo ovaj deo entity-ja iz baze
        };
        */
        //
        const _optimized_document = lib_document_utils_tabular_document_to_optimized_document(lib_obj);
        //
        cache_state.lib_ter_document_cache[item.lib_entity_key] = _optimized_document;
      }
    });
    cache_state.lib_ter_document_is_cached = true;
    console.log('lib_ter_document_is_cached');
  }
  return true;
};
//
export const lib_ter_document_cache_get = () => {
  return cache_state.lib_ter_document_cache;
};


export const lib_ter_cparams_cache_set = (arr) => {
  //
  // pretvaramo array u object i transformišemo iteme
  if (Array.isArray(arr)) {
    arr.forEach((item) => {
      if (item && item.lib_entity_key) {
        const data_json = item.data_json;
        const lib_obj = _cacheHelper_decodeLibEntityDataJsonV1(data_json);
        cache_state.lib_ter_cparams_cache[item.lib_entity_key] = {
          // ...item,
          // ..._compatibility_fix_lib_materijal_lim_lib_obj(lib_obj), // koristimo samo ovaj deo entity-ja iz baze
          ...lib_obj, // koristimo samo ovaj deo entity-ja iz baze
        };
      }
    });
    cache_state.lib_ter_cparams_cache_is_cached = true;
    console.log('lib_ter_cparams_cache_is_cached');
  }
  return true;
};
//
export const lib_ter_cparams_cache_get = () => {
  return cache_state.lib_ter_cparams_cache;
};

